import type {
  PostCardHandlers,
  PostCardIds,
  PostCardMeta,
  PostCardStatus,
  PostCardViewModel,
} from "@/components/common/PostCard";
import type { MediaFile } from "@/components/common/media-preview/types";
import { convertTimezoneToLocal } from "@/lib/utils/dateUtils";

interface BuildPostCardAuthor {
  name: string;
  id?: number;
  avatarUrl?: string | null;
}

interface BuildPostCardContent {
  body: string;
  originalBody?: string | null;
  studyGroupName?: string;
  files?: MediaFile[];
}

export interface BuildPostCardViewModelOptions {
  ids: PostCardIds;
  author: BuildPostCardAuthor;
  timestamp: string;
  content: BuildPostCardContent;
  status?: Partial<PostCardStatus>;
  handlers?: Partial<PostCardHandlers>;
}

export const buildPostCardViewModel = ({
  ids,
  author,
  timestamp,
  content,
  status = {},
  handlers = {},
}: BuildPostCardViewModelOptions): PostCardViewModel => {
  const meta: PostCardMeta = {
    author: author.name,
    authorId: author.id,
    timestamp,
    avatarUrl: author.avatarUrl ?? null,
    content: content.body,
    originalContent: content.originalBody ?? undefined,
    studyGroupName: content.studyGroupName,
    files: content.files,
  };

  return {
    meta,
    ids,
    status,
    handlers,
  };
};

export const formatPostTimestampFromUtc = (createdAt?: string): string => {
  if (!createdAt) return "";
  const { date, time } = convertTimezoneToLocal(createdAt, "UTC");
  if (!date || !time) return createdAt;
  return `${date} ${time}`;
};
